import icon from "../../assets/lan-port.svg";
import type { Property } from "../../types";

export const integratedSwitch: Property = {
  id: "integratedSwitch",
  title: "integratedSwitch.title",
  icon,
};
